import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function SoundOn() {
	let SwiperSoundon = () => {
    return (
			<div className="slider sliderIn">
        <div className="si_tab_soundon_tab">
            <Swiper
								spaceBetween={20}
								loop={true}
								centeredSlides={true}	// item放中間
								slidesPerView={1.5}
                navigation
								breakpoints={{
									767: {	// when window width is >= 767px
										spaceBetween: 30,
										slidesPerView: 5,
									},
								}}
            >
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/ceb508d0-2bde-41de-bbfe-2a1ff222593e" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_1.jpg").default} className="img-responsive" alt="法客電台" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/667f4ebd-fd54-4058-86b1-87f1810d5ee3" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_2.jpg").default} className="img-responsive" alt="我的老台北" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/b1b05458-5ae3-4cf8-a481-e079c26dbe72" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_4.jpg").default} className="img-responsive" alt="人渣文本特急開講" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/3dbafbf8-b792-4fe4-952f-34344933f2e6" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_3.jpg").default} className="img-responsive" alt="阿善師鑑識實錄" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/a15ce25e-2627-48ca-9587-d4cf5e98f3a1" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_5.jpg").default} className="img-responsive" alt="寶博朋友說" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/6df833ee-6c99-45b0-bb74-e54476e4a1de" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_6.jpg").default} className="img-responsive" alt="Ivy愛公葳" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/511455c6-f5ee-4e8f-aac3-912b277c0efe" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_7.jpg").default} className="img-responsive" alt="TK Talk 創投觀點" />
									</a>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div>
									<a href="https://player.soundon.fm/p/c1f1f3c9-8d28-42ad-9f1c-908018b8d9fc" target="_blank" rel="noreferrer">
										<img src={require("../../image/SoundOn/podcast_8.jpg").default} className="img-responsive" alt="《The Real Story》By 報導者" />
									</a>
								</div>
							</SwiperSlide>
            </Swiper>
        </div>
				</div>
    )
	}

	return (
		<div className="page_wrapper">
			<section className="sec sec_kv" id="sec_kv">
				<img src={require("../../image/SoundOn/kv.jpg").default} alt="kv" className="img-responsive hidden-xs" />
				<img src={require("../../image/SoundOn/kv_m.jpg").default} alt="kv_m" className="img-responsive hidden-sm hidden-md hidden-lg"/>
				<div className="text">
					<img src={require("../../image/SoundOn/kv_text.png").default} alt="kv_text" className="img-responsive hidden-xs" />
					<img src={require("../../image/SoundOn/kv_text_m.png").default} alt="kv_text_m" className="img-responsive hidden-sm hidden-md hidden-lg" />
					<div className="btn_part">
						<a href="/container/caption/Caption0304" target="_blank" className="btnStyle">什麼是i聽聽</a>
						<a href="https://www.soundon.fm/" target="_blank" className="btnStyle" rel="noreferrer">什麼是SoundOn</a>
					</div>
	
				</div>
			</section>
	
			<section className="sec sec_podcast" id="sec_podcast">
				<div className="container-fluid maxWidth">
					<div className="row">
						<div className="col-xs-12 col-md-12 text-center">
							<div className="sec_title">聲音席捲全球，Podcast正夯！</div>
							<div className="sec_subtitle">
								i寶貝打造聲控美學新風景，與台灣最強Podcast平台攜手合作，<br className="hidden-xs" />
								帶您用耳朵走進最台話題直播間！
							</div>
						</div>
					</div>
					<div className="space hxs hidden-xs"></div>
					<div className="row pic_part">
						<div className="col-xs-12 col-sm-4">
							<div className="picBox">
								<img src={require("../../image/SoundOn/pic_1.png").default} alt="pic_1" className="img-responsive" />
								<div className="picIn">
									<div className="pic_title">
										多元指令，輕鬆下達
									</div>
									<hr className="line" />
									<p>可以語音指令聲控i寶貝，<br />
										如「節目名、類別、創作者」<br />
										等多樣化關鍵字進行搜尋，<br />
										即可進行智慧播放！</p>
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-4">
							<div className="picBox picBox_middle">
								<img src={require("../../image/SoundOn/pic_2.png").default} alt="pic_2" className="img-responsive" />
								<div className="picIn">
									<div className="pic_title">
										呼叫寶貝，立馬點播
									</div>
									<hr className="line" />
									<p>「i寶貝，我要聽Podcast。」<br />
										「i寶貝，推薦我投資類的Podcast。」<br />
										「i寶貝，我要聽股癌Podcast最新一集。」<br />
										「i寶貝，播放i聽聽Podcast。」</p>
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-sm-4">
							<div className="picBox">
								<img src={require("../../image/SoundOn/pic_3.png").default} alt="pic_3" className="img-responsive" />
								<div className="picIn">
									<div className="pic_title">
										首創「台灣DNA」音箱
									</div>
									<hr className="line" />
									<p>史上第一台國台語雙聲道智慧音箱，友善支援Podcast火紅節目熱播！</p>
								</div>
							</div>
						</div>
					</div>
					<div className="space hsm hidden-xs"></div>
					<div className="space hss hidden-sm hidden-md hidden-lg"></div>
				</div>
			</section>
	
			<section className="sec sec_original" id="sec_original">
				<div className="container-fluid maxWidth">
					<div className="row">
						<div className="col-xs-12 col-md-12 text-center">
							<div className="sec_title sec_title_white"><span>SoundOn</span>原創節目介紹</div>
						</div>
					</div>
					<div className="slick_part">
						<SwiperSoundon />
					</div>
					<div className="btn_part">
						<a href="https://www.soundon.fm/soundon-originals" target="_blank" className="btnStyle" rel="noreferrer">了解更多節目</a>
					</div>
					<div className="space hmd hidden-xs"></div>
				</div>
			</section>
	
			<section className="sec sec_play" id="sec_play">
				<div className="container-fluid maxWidth">
					<div className="row">
						<div className="col-xs-12 col-md-12 text-center">
							<div className="sec_title">強打放送中</div>
						</div>
					</div>
					<div className="row play_part">
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/954689a5-3096-43a4-a80b-7810b219cef3" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_1.jpg").default} className="img-responsive" alt="Gooaye 股癌" />
							</a>
						</div>
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/a1157e51-549b-40c1-a16c-ce597629b8c2" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_2.jpg").default} className="img-responsive" alt="台灣通勤第一品牌" />
							</a>
						</div>
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/facac940-ab79-4f03-b99a-50e6b7df4d7d" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_3.jpg").default} className="img-responsive" alt="百靈果NEWS" />
							</a>
						</div>
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/e0baca98-490d-4f44-83c9-32f8ec8eec45" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_4.jpg").default} className="img-responsive" alt="聽天下：天下雜誌Podcast" />
							</a>
						</div>
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/ecd31076-d12d-46dc-ba11-32d24b41cca5" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_5.jpg").default} className="img-responsive" alt="呱吉" />
							</a>
						</div>
						<div className="col-xs-6 col-sm-4">
							<a href="https://player.soundon.fm/p/44833083-490d-4f97-a782-fd5e34c0abef" target="_blank" rel="noreferrer">
								<img src={require("../../image/SoundOn/player_6.jpg").default} className="img-responsive" alt="敏迪選讀" />
							</a>
						</div>
					</div>
					<div className="space hmd hidden-xs"></div>
					<div className="space hss hidden-sm hidden-md hidden-lg"></div>
				</div>
			</section>
	
		</div>
	)
}

export default SoundOn;